<template>
    <div id="email-form-container" :style="{ opacity: this.formStatus.isLoading ? 0.6 : 1 }">
        <FormIntro />
        <form
            v-if="!this.formStatus.isSent || this.formStatus.isLoading"
            class="form-group"
            id="email-form"
            @submit.prevent="handleSubmit($event.target)"
        >
            <div class="form-group">
                <label>{{ formFields.assunto.label }}</label>
                <div class="cr-select">
                    <select v-model="formData.assunto" name="assunto" required>
                        <option select disabled hidden value=""></option>
                        <option
                            v-for="option in formFields.assunto.options"
                            :key="option.value"
                            :value="option"
                        >
                            {{ option.text }}
                        </option>
                    </select>
                </div>
                <div class="mt-2" v-if="formData.assunto.url">
                    <span>Sua dúvida pode estar em</span>
                    <a :href="formData.assunto.url" target="_blank" class="link-helpcenter">
                        <span>{{ formData.assunto.message }}</span>
                    </a>
                </div>
            </div>
            <div class="form-group" v-for="input in formFields.textInputs">
                <label>{{ input.label }}</label>
                <input
                    v-if="input.name !== 'comentario'"
                    type="text"
                    v-model="formData[input.name]"
                    :name="input.name"
                    :required="input.isRequired"
                />
                <textarea
                    v-if="input.name === 'comentario'"
                    v-model="formData[input.name]"
                    :name="input.name"
                    :required="input.isRequired"
                />
            </div>
            <Checkbox
                v-for="input in formFields.checkboxInputs"
                :key="input.name"
                v-model="formData[input.name]"
                class="mb-0 mt-0"
                :label="input.label"
                :name="input.name"
            />
            <FormCaptcha
                :recaptchaResponse.sync="formData['g-recaptcha-response']"
                :isRecaptchaVerified.sync="formStatus.isRecaptchaVerified"
            />

            <button
                id="btn-submit-emailform"
                type="submit"
                class="btn"
                :disabled="!formStatus.isRecaptchaVerified"
                :class="!formStatus.isRecaptchaVerified && 'btn-submit-disabled'"
            >
                Enviar
            </button>
        </form>
        <SuccessFormMessage
            v-if="this.formStatus.isSent && this.formStatus.isSuccessful === true"
            :returnToForm="returnToForm"
            :formStatus="this.formStatus"
        />
        <ErrorFormMessage
            v-if="this.formStatus.isSent && this.formStatus.isSuccessful === false"
            :returnToForm="returnToForm"
        />
    </div>
</template>

<script>
    import Checkbox from '@bit/chicorei.chicomponents.input.checkbox';
    import FormCaptcha from './FormCaptcha.vue';
    import FormIntro from './FormIntro.vue';
    import cr$ from '../../../common/crquery';
    import SuccessFormMessage from './SuccessFormMessage.vue';
    import ErrorFormMessage from './ErrorFormMessage.vue';

    export default {
        name: 'EmailForm',
        components: { FormIntro, Checkbox, FormCaptcha, SuccessFormMessage, ErrorFormMessage },
        data() {
            return {
                formFields: {
                    assunto: {
                        label: 'Assunto *',
                        options: [
                            {
                                text: 'Dúvida',
                                value: 'duvida',
                                message: 'Central de Ajuda',
                                url: '/central-de-ajuda',
                            },
                            {
                                text: 'Troca e Devolução',
                                value: 'troca-e-devolucao',
                                message: 'Trocas e Devoluções',
                                url: '/central-de-ajuda/#reamaze#0#/kb/trocas-devolucoes',
                            },
                            {
                                text: 'Entrega',
                                value: 'entrega',
                                message: 'Prazos e Envio',
                                url: '/central-de-ajuda/#reamaze#0#/kb/envio',
                            },
                            { text: 'Elogio', value: 'elogio' },
                            { text: 'Sugestão', value: 'sugestao' },
                            { text: 'Reclamação', value: 'reclamacao' },
                            {
                                text: 'Outro',
                                value: 'outro',
                                message: 'Central de Ajuda',
                                url: '/central-de-ajuda/',
                            },
                        ],
                        url: {
                            duvida: '/central-de-ajuda',
                            'troca-e-devolucao':
                                '/central-de-ajuda/#reamaze#0#/kb/trocas-devolucoes',
                            entrega: '/central-de-ajuda/#reamaze#0#/kb/envio',
                            outro: '/central-de-ajuda/',
                        },
                        isRequired: true,
                    },
                    textInputs: [
                        {
                            label: 'Nome *',
                            name: 'nome',
                            isRequired: true,
                        },
                        {
                            label: 'E-mail *',
                            name: 'email',
                            isRequired: true,
                        },
                        {
                            label: 'Número do Pedido',
                            name: 'pedido',
                            isRequired: false,
                        },
                        {
                            label: 'Mensagem *',
                            name: 'comentario',
                            isRequired: true,
                        },
                    ],
                    checkboxInputs: [
                        {
                            label: 'Receber novidades e promoções por email',
                            name: 'newsletter',
                            isRequired: false,
                        },
                    ],
                },
                formData: {
                    assunto: '',
                    nome: '',
                    email: '',
                    pedido: '',
                    comentario: '',
                    newsletter: false,
                    'g-recaptcha-response': '',
                },
                formStatus: {
                    data: {},
                    isSent: false,
                    isLoading: null,
                    isSuccessful: null,
                    isRecaptchaVerified: null,
                },
                responseData: {},
            };
        },
        methods: {
            handleSubmit() {
                this.formStatus.isLoading = true;

                this.formStatus.data = new FormData();
                this.formStatus.data.append('assunto', this.formData.assunto.text);
                this.formStatus.data.append('nome', this.formData.nome);
                this.formStatus.data.append('email', this.formData.email);
                this.formStatus.data.append('pedido', this.formData.pedido);
                this.formStatus.data.append('comentario', this.formData.comentario);
                this.formStatus.data.append('newsletter', this.formData.newsletter);
                this.formStatus.data.append(
                    'g-recaptcha-response',
                    this.formData['g-recaptcha-response']
                );

                this.formStatus.isSent = true;

                this.axios.http
                    .post('/contato.php', this.formStatus.data, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    })
                    .then((response) => {
                        this.formStatus.isLoading = null;

                        if (response.status === 200) {
                            this.formStatus.isSuccessful = true;
                        } else {
                            this.formStatus.isSuccessful = false;
                        }
                    })
                    .catch((response) => {
                        console.log(response);
                    })
                    .finally(() => {
                        cr$.byId('email-form-container').scrollIntoView();
                    });
            },
            returnToForm() {
                this.formStatus.isSent = false;
                this.formStatus.isSuccessful = null;
                this.formStatus.isRecaptchaVerified = false;
                this.resetForm();
            },
            resetForm() {
                this.formData = {
                    assunto: '',
                    nome: '',
                    email: '',
                    pedido: '',
                    comentario: '',
                    newsletter: false,
                    promocoes: false,
                    'g-recaptcha-response': '',
                };
            },
        },
    };
</script>